import { SelectType } from "@/enum/list.enum";

import { BulkBlacklist } from "@/pages/Private/pages/List/schema/bulk-blacklist";

import { BulkStatusScope } from "./getBulkStatusScope";

interface BulkBlacklistRequestInput {
	listId: number;
	/** A lead picked from its row's menu: it alone is blacklisted, whatever is selected. */
	pickedRowId?: number | null;
	/** The selected leads; for a select-all, the loaded page's leads. */
	selectedItems: number[];
	/** The table's filters, search term and tab statuses, from `getBulkStatusScope`. */
	scope: BulkStatusScope;
	addCompany: boolean;
}

/**
 * The `POST list/bulk-blacklist` body for the list table's "Add to Blacklist" (PREC-4435). A
 * select-all carries every dimension the table fetched its rows with, the search term and the
 * tab included, because the server writes an entry for every lead it resolves: a dimension left
 * out would blacklist leads the user never saw.
 */
export function buildBulkBlacklistRequest(input: BulkBlacklistRequestInput): BulkBlacklist {
	const { listId, pickedRowId, selectedItems, scope, addCompany } = input;

	if (pickedRowId) {
		return {
			listId,
			assign: [{ listPersonId: pickedRowId }],
			selectType: SelectType.CURRENT_PAGE,
			addCompany,
		};
	}

	const assign = selectedItems.map((listPersonId) => ({ listPersonId }));

	if (scope.selectType !== SelectType.ALL) {
		return { listId, assign, selectType: SelectType.CURRENT_PAGE, addCompany };
	}

	return { listId, assign, ...scope, addCompany };
}
